import { ChatApiMain } from '../../public_html/assets/js/chat-api/chat-api.js';

window.ChatApiMain = ChatApiMain;
